import { useEffect, useState } from "react";
import { loadServiceStatusMap } from "../Constants/serviceOrderStatus";

/**
 * The service-order status id ⇄ name map, loaded from the backend.
 *
 * The service NOTIFY payload carries only ids, so handlers translate them here
 * rather than keeping a hand-written copy of the lookup (COMY1-283).
 */
const useServiceStatusMap = () => {
  const [map, setMap] = useState({ idByName: {}, nameById: {} });

  useEffect(() => {
    let active = true;
    loadServiceStatusMap().then((loaded) => {
      if (active) setMap(loaded);
    });
    return () => {
      active = false;
    };
  }, []);

  return map;
};

export default useServiceStatusMap;
